import { TbordOneToneIcon } from '../components/NudosComponents/BordOneToneIcon/BordOneToneIcon.types';

export interface IBulkUploadButton {
  text: string;
  icon: TbordOneToneIcon;
  route: string;
}

export interface IBulkUploadCard {
  title: string;
  description: string;
  icon: TbordOneToneIcon;
  firstButton: IBulkUploadButton;
  secondButton: IBulkUploadButton;
  isOnlyDevsAutomates?: boolean;
}

export interface IUploadCatalogResponse {
  errors: string[];
  totalRecords: number;
  updatedRecords: number;
  errorFileUrl?: string;
}

export interface IUploadResults {
  errors?: string[];
  totalRecords: number;
  updatedRecords: number;
}

export type TResultUploadSales = {
  totalOrders: number;
  ordersWithErrors: number;
  createdOrders: number;
  errors: TErrorsByOrder[];
  errorFileUrl?: string;
};

export type TErrorsByOrder = {
  order: number;
  errors: Array<string | TErrorByOrder>;
};

export type TErrorByOrder = {
  message: string;
  rowIndex?: number;
  field?: string;
  value?: any;
};

export enum QUOTE_TYPE {
  REGULAR = 'REGULAR',
  EXPLORATORY = 'EXPLORATORY'
}
